import React from 'react';

export default function Contact() {
  return (
    <div
      style={{
        padding: '40px',
        color: '#F3E5AB',
        fontFamily: 'Milonga, serif',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '48px', marginBottom: '20px' }}>Contact Me</h1>
      <p style={{ fontSize: '24px' }}>
        Please fill out this form to contact me
      </p>

      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLScEGtMmN84zIYT6y7h2PccksTEBAUxdd3K5NAvA0MRfkJqO9g/viewform?embedded=true"
        title="Contact form"
        width="640"
        height="686"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
      >
        Loading...
      </iframe>
    </div>
  );
}
